import React from 'react'
import { TypeAnimation } from 'react-type-animation';

export default function Home() {
  return <>

      
<header id="home" className='vh-100 d-flex align-items-center justify-content-center w-100'>
        <div className="row">
          <div className="col-md-12  text-center">
            <h2 className='mb-3'>Welcome to our community</h2>
            {/* Text Animation in homepage */}
          <h5> 
          <TypeAnimation
        sequence={['Cloud Compute Services',2500,'SRO Services',2500]}
        speed={200}
        repeat={Infinity}/>
          </h5>  
          </div>
        </div>
      </header>


  

  
  </>
}
